import React from 'react';
import BasketItem from "./BasketItem";

class Basket extends React.Component {
    render() {
        let deliveryHTML = (this.props.deliveryPrice > 0) ? this.props.deliveryPrice + ' <i className="fas fa-ruble-sign"/>': 'бесплатно';
        deliveryHTML = 'Доставка в пределах МКАД: ' + deliveryHTML;
        return (
            <div className="basket-items">
                <div className="basket-items__header">
                    <div className="image">Картинка</div>
                    <div className="title">Название</div>
                    <div className="price">Цена</div>
                    <div className="quantity">Кол-во</div>
                    <div className="total_price">Сумма</div>
                    <div className="remove">&nbsp;</div>
                </div>
                <div className="basket-items__body">
                    {
                        this.props.items.map(
                            (item, index) =>
                                <BasketItem key={item.id}
                                            item={item}
                                            zeroPrice={this.props.zeroPrice}
                                            _onChangeBasketHandle={(value) => this.props._onChangeBasketHandle(value, index)}
                                            _onRemoveBasketItem={id => this.props._onRemoveBasketItem(id)}
                                />
                        )
                    }
                    {/*<div className="delivery" dangerouslySetInnerHTML={{__html:deliveryHTML}} />*/}
                </div>
            </div>
        );
    }
}

export default Basket;


